import React, { useEffect, useState } from "react";
import { fetchTaskReports } from "../../../api/api";
import { useTranslation } from "react-i18next";

const TaskStatusReports = () => {
  const { t } = useTranslation();
  const [tasks, setTasks] = useState<any[]>([]);
  const [statusFilter, setStatusFilter] = useState("all");//for filtering tasks by status

const formatLocalDate = (dateStr: string) => {
  if (!dateStr) return "--";

  const d = new Date(dateStr);

  return (
    d.getFullYear() +
    "-" +
    String(d.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(d.getDate()).padStart(2, "0")
  );
};
  const filteredTasks =
  statusFilter === "all"
    ? tasks
    : tasks.filter(
        (task: any) =>
          (task.status || "").toLowerCase() ===
          statusFilter.toLowerCase()
      );

  useEffect(() => {
    loadReports();
  }, []);

  const loadReports = async () => {
  try {
    const data = await fetchTaskReports();

    console.log("ALL TASKS:", data);

    // logged in username
    const username =
      (localStorage.getItem("username") || "")
        .trim()
        .toLowerCase();

    // admin check
    const token = localStorage.getItem("token");

    let isAdmin = false;

    if (token) {
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        isAdmin = payload?.isAdmin === true;
      } catch (err) {
        console.error("Invalid token", err);
      }
    }

    // ADMIN → SHOW ALL
    if (isAdmin) {
      setTasks(data);
      return;
    }

    // USER  SHOW ONLY ASSIGNED TASKS
    const filteredTasks = data.filter((task: any) => {
      const holder =
        (task.task_holder || "")
          .trim()
          .toLowerCase();

      return holder === username;
    });

    console.log("FILTERED TASKS:", filteredTasks);

    setTasks(filteredTasks);

  } catch (err) {
    console.error(err);
  }
};

  return (
    <div className="page-wrapper">
      <div className="content">

        <div className="page-header">
          <h4>{t("taskReports")}</h4>
        </div>
       {/* filter */}
        <div
        className="d-flex align-items-center justify-content-between mb-3"
      >
        <select
          className="form-select"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          style={{
            width: "220px",
            borderRadius: "8px",
            border: "1px solid #d0d5dd",
            boxShadow: "none",
          }}
        >
          <option value="all">{t("allTasks")}</option>
          <option value="Completed">{t("statusCompleted")}</option>
          <option value="On Work">{t("onWork")}</option>
          <option value="Inactive">{t("inactive")}</option>
          <option value="Active">{t("active")}</option>
        </select>
              </div>
        {/* filter */}

        <div className="card">
          <div className="card-body">

            <div className="table-responsive">
            <table
              className="table align-middle"
              style={{
                border: "1px solid #e5e7eb",
              }}
            >
              <thead
                style={{
                  backgroundColor: "#f8f9fa",
                }}
              >
                <tr>
                  <th style={{ border: "1px solid #e5e7eb" }}>{t("id")}</th>
                  <th style={{ border: "1px solid #e5e7eb" }}>{t("title")}</th>
                  <th style={{ border: "1px solid #e5e7eb" }}>{t("category")}</th>
                  <th style={{ border: "1px solid #e5e7eb" }}>{t("responsible")}</th>
                  <th style={{ border: "1px solid #e5e7eb" }}>{t("priority")}</th>
                  <th style={{ border: "1px solid #e5e7eb" }}>{t("status")}</th>
                  <th style={{ border: "1px solid #e5e7eb" }}>{t("startDate")}</th>
                  <th style={{ border: "1px solid #e5e7eb" }}>{t("dueDate")}</th>
                  <th style={{ border: "1px solid #e5e7eb" }}>{t("completedDate")}</th>
                </tr>
              </thead>

              <tbody>
                {filteredTasks.length > 0 ? (
                filteredTasks.map((task: any) => (
                    <tr key={task.tid}>

                      <td style={{ border: "1px solid #e5e7eb" }}>
                        #{task.tid}
                      </td>

                      <td
                        style={{
                          border: "1px solid #e5e7eb",
                          fontWeight: 600,
                        }}
                      >
                        {task.title}
                      </td>

                      <td style={{ border: "1px solid #e5e7eb" }}>
                        {task.category || "--"}
                      </td>

                      <td style={{ border: "1px solid #e5e7eb" }}>
                        {task.task_holder || "--"}
                      </td>

                      {/* PRIORITY */}
                      <td style={{ border: "1px solid #e5e7eb" }}>
                        {task.priority ? (
                          <span
                            style={{
                              padding: "5px 10px",
                              borderRadius: "6px",
                              fontSize: "13px",
                              fontWeight: 600,
                              backgroundColor:
                                task.priority === "High"
                                  ? "#fdeaea"
                                  : task.priority === "Medium"
                                  ? "#fff7e6"
                                  : "#edf4ff",

                              color:
                                task.priority === "High"
                                  ? "#d92d20"
                                  : task.priority === "Medium"
                                  ? "#b26a00"
                                  : "#175cd3",
                            }}
                          >
                            {task.priority}
                          </span>
                        ) : (
                          "--"
                        )}
                      </td>

                      {/* STATUS */}
                      <td style={{ border: "1px solid #e5e7eb" }}>
                        {task.status ? (
                          <span
                            style={{
                              padding: "5px 10px",
                              borderRadius: "6px",
                              fontSize: "13px",
                              fontWeight: 600,

                              backgroundColor:
                                task.status === "Completed"
                                  ? "#e8f7ee"
                                  : task.status === "On Work"
                                  ? "#fff7e6"
                                  : task.status === "Inactive"
                                  ? "#fdeaea"
                                  : "#edf4ff",

                              color:
                                task.status === "Completed"
                                  ? "#067647"
                                  : task.status === "On Work"
                                  ? "#b26a00"
                                  : task.status === "Inactive"
                                  ? "#d92d20"
                                  : "#175cd3",
                            }}
                          >
                            {task.status}
                          </span>
                        ) : (
                          "--"
                        )}
                      </td>

                      {/* START DATE */}
                      <td style={{ border: "1px solid #e5e7eb" }}>
                        {task.start_date
                        ? formatLocalDate(task.start_date)
                        : "--"}
                      </td>

                      {/* DUE DATE */}
                      <td style={{ border: "1px solid #e5e7eb" }}>
                        {task.due_date
                        ? task.due_date.split("T")[0]
                        : "--"}
                      </td>

                      {/* COMPLETED DATE */}
                      <td style={{ border: "1px solid #e5e7eb" }}>
                        {task.completed_date ? (
                          <span
                            style={{
                              color: "#067647",
                              fontWeight: 600,
                            }}
                          >
                            {formatLocalDate(task.completed_date)}
                          </span>
                        ) : (
                          "--"
                        )}
                      </td>

                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={9}
                      className="text-center"
                      style={{
                        border: "1px solid #e5e7eb",
                        padding: "20px",
                      }}
                    >
                     {t("noTaskReportsFound")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default TaskStatusReports;